import * as React from 'react'
import styled from 'styled-components'
import { datItemStyles } from './DatItem'

const DatItemButton = styled.button`
  ${datItemStyles}
  --dat-accent: rgba(148, 163, 184, 0.42);
  justify-content: center;
  min-width: 0;
  min-height: 42px;
  padding-inline: 14px;
  background: rgba(30, 41, 59, 0.9);
  color: #f8fafc;
  line-height: 1.25;
  font-size: 0.84rem;
  font-weight: 620;
  text-align: center;
  overflow-wrap: anywhere;
  cursor: pointer;

  &:hover {
    border-color: rgba(148, 163, 184, 0.22);
    background: rgba(30, 41, 59, 1);
  }
`

type Props = {
  onClick?: () => void
  children?: React.ReactNode
}

export const DatButton = (props: Props) => (
  <DatItemButton type="button" onClick={props.onClick}>
    {props.children}
  </DatItemButton>
)
